export const AUTHORISED_DISTRIBUTORS = 'ad';
export const PARALLEL_IMPORTERS = 'pi';

export const FILTER_TYPE_NAME_OMV = 'OMV';
export const FILTER_TYPE_NAME_ENERGY_CONSUPTION = 'Energy Consumption';
export const FILTER_TYPE_NAME_POWER_OUTPUT = 'Power Output';
export const FILTER_TYPE_NAME_FUEL_CONSUMPTION = 'Fuel Consumption';
export const FILTER_TYPE_NAME_PRICE_RANGE = 'Price Range';
export const FILTER_TYPE_NAME_DEPRECIATION = 'Depreciation';
export const FILTER_TYPE_NAME_DRIVE_RANGE = 'Drive Range';
export const FILTER_TYPE_NAME_TRANSIMISSION = 'Transmission';
export const FILTER_TYPE_NAME_ENGINE_CAP = 'Engine Cap';
export const FILTER_TYPE_NAME_DEALER_TYPE = 'Dealer Type';
export const FILTER_TYPE_NAME_FUEL_TYPE = 'Fuel Type';
export const FILTER_TYPE_NAME_CATEGORY = 'Category';
export const FILTER_TYPE_NAME_COE_TYPE = 'Coe Type';
export const FILTER_TYPE_NAME_COUNTRY = 'Country';

export const VEHICLE_NAME_SUV = 'SUV';
export const VEHICLE_NAME_MPV = 'MPV';
export const VEHICLE_NAME_HYBRID_CARS = 'Hybrid Cars';
export const VEHICLE_NAME_ELECTRIC_CARS = 'Electric Cars';
export const VEHICLE_NAME_LUXURY_SEDAN = 'Luxury Sedan';
export const VEHICLE_NAME_MID_SIZED_SEDAN = 'Mid-Sized Sedan';
export const VEHICLE_NAME_SPORTS_CARS = 'Sports';
export const VEHICLE_NAME_HATCHBACK = 'Hatchback';
export const VEHICLE_NAME_STATIONWAGON = 'Stationwagon';
export const VEHICLE_NAME_ALL_COMMERCIAL_VEHICLES = 'All Commercial Vehicles';
export const VEHICLE_NAME_ALL_PASSENGER_CARS = 'All Passenger Cars';
export const VEHICLE_VALUE_SUV = 'suv';
export const VEHICLE_VALUE_MPV = 'mpv';
export const VEHICLE_VALUE_HYBRID_CARS = 'hybrid';
export const VEHICLE_VALUE_ELECTRIC_CARS = 'electric';
export const VEHICLE_VALUE_LUXURY_SEDAN = 'luxury';
export const VEHICLE_VALUE_MID_SIZED_SEDAN = 'sedan';
export const VEHICLE_VALUE_SPORTS_CARS = 'sports';
export const VEHICLE_VALUE_HATCHBACK = 'hatchback';
export const VEHICLE_VALUE_STATIONWAGON = 'stationwagon';
export const VEHICLE_VALUE_ALL_COMMERCIAL_VEHICLES = 'commercial';
export const VEHICLE_VALUE_ALL_PASSENGER_CARS = 'passenger';
